require('./bootstrap');
import {Inertia} from '@inertiajs/inertia';
import { InertiaProgress } from '@inertiajs/progress';
import {app, plugin} from '@inertiajs/inertia-vue'
import Vue from 'vue';
import VueMeta from 'vue-meta'
import VueYouTubeEmbed from "vue-youtube-embed";
import vueVimeoPlayer from 'vue-vimeo-player'
import PortalVue from 'portal-vue';

Vue.use(VueMeta);
Vue.use(plugin);
Vue.use(VueYouTubeEmbed, {global: true, componentId: "YoutubeVideo"});
Vue.use(vueVimeoPlayer);
Vue.use(PortalVue);

window.Bus = new Vue({
    name: "notifications-bus"
});

InertiaProgress.init({
    delay: 50,
    color: '#bc1d2e',
    includeCSS: true,
    showSpinner: false,
})

Inertia.on('navigate', event => {
    if (typeof dataLayer !== 'undefined' && typeof dataLayer.push !== 'undefined') {
        dataLayer.push({event: 'pageview'})
    }
});

const el = document.getElementById('app');

new Vue({
    data: {
        navigating: false
    },
    mounted() {},
    render: h => h(app, {
        props: {
            initialPage: JSON.parse(el.dataset.page),
            resolveComponent: name => require(`./Pages/${name}`).default,
        },
    }),
}).$mount(el);
